import React from "react";
import { useNavigate, Link } from "react-router-dom"; 

function DashboardHeader({onLogout}) {
    const navigate = useNavigate();
    const handleLogoutClick = () => {
        onLogout();
        navigate('/admin/login'); 

    }
    return (       
        <nav className="dashboard-nav">
                <div className="logo">
                    <a href="http://localhost:3000/">
                        <span className="fa fa-wordpress"></span>
                    </a>
                </div>
                <ul className="main-nav">
                    <li>
                        <Link to="/admin/dashboard">
                            <span className="fa fa-home"></span>
                            Dashboard
                        </Link>
                    </li>
                    <li>
                        <Link to="/admin/locations">
                            <span className="fa fa-home"></span>
                            Locations
                        </Link>
                    </li>

                    <li>
                        <Link to="/admin/events">
                            <span className="fa fa-home"></span>
                            Events
                        </Link>
                    </li>

                    <li>
                        <a onClick={handleLogoutClick} className="logout-btn">
                            <span className="fa fa-sign-out"></span>
                            Logout
                        </a>
                    </li>                   
                </ul>
            </nav>
    );
}

export default DashboardHeader;
